import { SmartLink, Button, YStack, isWeb } from '@my/ui'
import config from 'app/config'
import { useIFrame } from 'app/provider/iframe'
import React from 'react'
import { useRouter } from 'solito/router'
import { useCurrentRoute } from 'app/hooks'

interface RegisterDialogPageProps {
  offerSlug?: string
  isEmbed?: boolean
  embedUrl?: string
}

export function RegisterDialogPage({ offerSlug, isEmbed, embedUrl }: RegisterDialogPageProps) {
  const isFrame = isEmbed

  const { replace } = useRouter()
  const {
    getCurrentRoute,
    setCurrentRoute,
  } = useCurrentRoute();

  const postMessage = (type: string, payload: any = {}) => {
    if (!isWeb) return
    parent.postMessage(
      {
        type,
        payload,
      },
      embedUrl || config.siteUrl
    )
  }

  const embedJoinClick = (e) => {
    if (!isFrame || !isWeb) return
    e.preventDefault()

    const joinUrl = `${config.siteUrl}/sign-up${linkSuffix}`

    postMessage('join', joinUrl)
  }

  const linkSuffix = offerSlug ? `?offerSlug=${offerSlug}&isEmbed=${isFrame}` : ''

  const handleLoginClick = () => {
    const currentRoute = getCurrentRoute()
    setCurrentRoute(currentRoute)

    replace(isFrame ? `/log-in-embed${linkSuffix}` : '/log-in')
  }

  return (
    <YStack pt="$4" gap="$3" width="100%" maxWidth={400}>
      <SmartLink
        Component={Button}
        plain
        backgroundColor="$primary"
        href={isFrame ? '#' : '/sign-up'}
        w="100%"
        size="$4"
        fow="600"
        onPress={embedJoinClick}
      >
        Join now!
      </SmartLink>
      <Button
        size="$4"
        fow="600"
        unstyled
        onPress={handleLoginClick}
        w="100%"
      >
        Log in
      </Button>
    </YStack>
  )
}
